module.exports = {"id":"209218","name":"Jehad Al Hussien","rating":"72","photo":"./data/images/photos/0/209218.png","club":{"name":"Al Taawoun","logo":"./data/images/clubs/AlTaawoun.png"},"positions":["MOC","MC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JehadAlHussien0.json
// module id = 1971
// module chunks = 0